export default function Footer() {
  return (
    <footer className="relative z-10 px-6 py-12 border-t border-white/10 bg-black/20 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto text-center space-y-6">
        {/* Logo e Nome */}
        <div className="flex justify-center items-center gap-3 mb-4">
          <img
            src="/assets/ralui-tech.png"
            alt="Logo Ralui Tech"
            className="w-16 h-16 object-contain"
          />
          <span className="text-xl font-bold bg-gradient-to-r from-purple-400 to-blue-400 bg-clip-text text-transparent">
            RALUI TECH
          </span>
        </div>

        {/* Slogan */}
        <p className="text-slate-400">
          Transformando ideias em soluções digitais desde 2026
        </p>

        {/* Redes Sociais */}
        <div className="flex justify-center gap-6 pt-2 pb-6">
          {/* <a
            href="https://linkedin.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-slate-400 hover:text-purple-400 transition-colors"
          >
            LinkedIn
          </a>
          <a
            href="https://github.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-slate-400 hover:text-purple-400 transition-colors"
          >
            GitHub
          </a> */}
          <a
            href="https://instagram.com/raluitech"
            target="_blank"
            rel="noopener noreferrer"
            className="text-slate-400 hover:text-purple-400 transition-colors"
          >
            Instagram
          </a>
        </div>

        {/* --- A FRASE CRISTÃ --- */}
        {/* Criei este bloco com borda superior para separar */}
        <div className="pt-8 border-t border-white/10">
          <p className="text-slate-500 font-serif italic text-sm md:text-base">
            "Tudo o que fizerem, façam de todo o coração, como para o Senhor e
            não para os homens."
          </p>
          <span className="text-xs text-slate-600 mt-1 block font-serif">
            — Colossenses 3:23
          </span>
        </div>

        {/* Copyright */}
        <p className="text-xs text-slate-600 pt-4">
          © 2026 RALUI TECH. Todos os direitos reservados.
        </p>
      </div>
    </footer>
  );
}
